// extracted by mini-css-extract-plugin
module.exports = {"Splash":"Splash_Splash__2rn7U","fade":"Splash_fade__2JYxO"};